import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import boston__asset from "@/assets/restore/locations/boston.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Boston",
    address: "75 Arlington Street, Suite 500",
    img: boston__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=75+Arlington+Street+Boston+MA",
    to: "/locations/massachusetts/boston/",
  },
];

export const Route = createFileRoute("/locations/massachusetts/")({
  head: () => ({
    meta: [
      { title: "Massachusetts Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Massachusetts. Book a free personal hair loss consultation at our Boston location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Massachusetts Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Boston, Massachusetts and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/massachusetts/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/massachusetts/" }],
  }),
  component: () => <StateLocationsHub stateName="Massachusetts" cities={cities} />,
});